import { WBCheckbox, WBFlex, WBLinkButton } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useModal } from '../../../features/components/ModalManager/ModalContext';
import { useDocuments } from '../../../features/pages/Documents/useDocuments';
import { DocumentType, Template, TemplateType } from '@admiin-com/ds-graphql';
import { useFormContext } from 'react-hook-form';
import { BillCreateFormData } from '../../../features/providers/TaskCreationProvider/TaskCreationProvider';

export const SendTemplateOption = ({
  checked,
  onChange,
  type = DocumentType.BAS,
}: {
  type: DocumentType | 'BINDING';
  checked: boolean;
  onChange: (
    checked: boolean,
    templateJson?: string,
    templateHtml?: string,
    includeLetterhead?: boolean
  ) => void;
}) => {
  const { watch } = useFormContext();
  const { t } = useTranslation();
  const { openModal } = useModal();

  const { documents } = useDocuments({
    searchName: '',
  });

  const [template, setTemplate] = useState<Template | null>(null);
  const [templateManuallyUpdated, setTemplateManuallyUpdated] = useState(false);

  React.useEffect(() => {
    // Don't override template if it was manually updated through editing
    if (templateManuallyUpdated) return;

    const targetType =
      type === 'BINDING'
        ? TemplateType.TAX_BINDING
        : type === DocumentType.NONE
        ? undefined
        : TemplateType[type as keyof typeof TemplateType];

    const initialTemplate = documents?.find(
      (document: Template) =>
        targetType !== undefined && document.type === targetType
    );

    if (initialTemplate && initialTemplate !== template) {
      setTemplate(initialTemplate);

      // If sendTemplate is already checked, update the form values with the new template
      if (checked) {
        onChange(
          checked,
          initialTemplate.templateJson ?? undefined,
          initialTemplate.templateHtml ?? undefined,
          initialTemplate.includeLetterhead ?? undefined
        );
      }
    } else if (!initialTemplate) {
      setTemplate(null);
    }
  }, [documents, type, checked, onChange, template, templateManuallyUpdated]);

  if (!template) return null;

  return (
    <WBFlex gap={1} alignItems="center">
      <WBCheckbox
        label={t('sendTemplate', {
          ns: 'taskbox',
          defaultValue: 'Send Cover Letter',
        })}
        checked={checked}
        onChange={(event, checked) => {
          onChange(
            checked,
            template?.templateJson ?? undefined,
            template?.templateHtml ?? undefined,
            template?.includeLetterhead ?? undefined
          );

          // if (checked) {
          //   openModal('documentCreate', {
          //     template: template,
          //     taxCreate: true,
          //     onSuccess: (template: Template) => {
          //       setTemplate(template);
          //       onChange(
          //         true,
          //         template.templateJson ?? undefined,
          //         template.templateHtml ?? undefined,
          //         template.includeLetterhead ?? undefined
          //       );
          //     },
          //     taskCreationContext: watch(),
          //   });
          // }
        }}
      />
      <WBFlex gap={1}>
        <WBLinkButton
          color="primary.main"
          onClick={() => {
            openModal('documentCreate', {
              template: template,
              taxCreate: true,
              onSuccess: (template: Template) => {
                console.log('templatetemplatetemplate: ', template);
                setTemplate(template);
                setTemplateManuallyUpdated(true); // Set the flag when template is manually updated
                onChange(
                  true, // Always set to true when template is successfully edited
                  template.templateJson ?? undefined,
                  template.templateHtml ?? undefined,
                  template.includeLetterhead ?? undefined
                );
              },
              taskCreationContext: watch() as BillCreateFormData,
            });
          }}
        >
          {t('edit', { ns: 'taskbox', defaultValue: 'Edit' })}
        </WBLinkButton>
        <WBLinkButton
          color="primary.main"
          onClick={() => {
            openModal('documentPreview', {
              templateHtml: template?.templateHtml ?? undefined,
              taskCreationContext: watch() as BillCreateFormData,
              includeLetterhead: template?.includeLetterhead ?? undefined,
              templateType: template?.type,
            });
          }}
        >
          {t('preview', { ns: 'taskbox', defaultValue: 'Preview' })}
        </WBLinkButton>
      </WBFlex>
    </WBFlex>
  );
};
